import { useLocale } from '../i18n'

function ProductsPage() {
  const { t } = useLocale()

  const products = [
    { id: 1, name: 'iPhone 15 Pro', price: 'NT$ 36,900', categoryKey: 'smartphone' },
    { id: 2, name: 'MacBook Air M2', price: 'NT$ 37,900', categoryKey: 'laptop' },
    { id: 3, name: 'AirPods Pro', price: 'NT$ 7,490', categoryKey: 'headphones' },
    { id: 4, name: 'Apple Watch', price: 'NT$ 12,900', categoryKey: 'smartwatch' },
    { id: 5, name: 'iPad Air', price: 'NT$ 19,900', categoryKey: 'tablet' },
    { id: 6, name: 'Magic Keyboard', price: 'NT$ 8,990', categoryKey: 'keyboard' }
  ]
  
  const handleAddToCart = (product) => {
    if (typeof window.DC !== 'undefined' && window.DC.addToCart) {
      window.DC.addToCart({
        items: [{
          item_id: `product_${product.id}`,
          item_name: product.name,
          category: t(`products.categories.${product.categoryKey}`),
          quantity: 1,
          price: parseInt(product.price.replace(/[^\d]/g, ''))
        }]
      })
    }
    alert(t('products.added', { name: product.name }))
  }
  
  return (
    <div className="content">
      <h2 className="page-title">{t('products.title')}</h2>
      <p className="page-description">{t('products.desc')}</p>
      
      <div className="product-grid">
        {products.map(product => (
          <div key={product.id} className="product-card">
            <div className="product-image">
              📱 {t(`products.categories.${product.categoryKey}`)}
            </div>
            <div className="product-info">
              <div className="product-title">{product.name}</div>
              <div className="product-price">{product.price}</div>
              <button 
                className="demo-button"
                onClick={() => handleAddToCart(product)}
              >
                {t('products.add')}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductsPage
